import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { CartProvider } from './context/CartContext';
import { AuthProvider } from './context/AuthContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import LoginModal from './components/LoginModal';
import Home from './pages/Home';
import Shop from './pages/Shop';
import ProductDetail from './pages/ProductDetail';
import About from './pages/About';
import Contact from './pages/Contact';
import Ingredients from './pages/Ingredients';
import Blog from './pages/Blog';
import InfoPage from './pages/InfoPage';
import Profile from './pages/Profile';
import Checkout from './pages/Checkout';
import OrderSuccess from './pages/OrderSuccess';
import TrackOrder from './pages/TrackOrder';
import './index.css';

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <CartProvider>
          <div className="flex flex-col min-h-screen">
            <Navbar />
            <LoginModal />
            <div className="flex-1">
              <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/shop" element={<Shop />} />
              <Route path="/product/:id" element={<ProductDetail />} />
              <Route path="/ingredients" element={<Ingredients />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/disclaimer" element={<InfoPage pageKey="disclaimer" />} />
              <Route path="/privacy-notice" element={<InfoPage pageKey="privacy" />} />
              <Route path="/terms-and-conditions" element={<InfoPage pageKey="terms" />} />
              <Route path="/grievances" element={<InfoPage pageKey="grievances" />} />
              <Route path="/checkout" element={<Checkout />} />
              <Route path="/order-success/:orderId" element={<OrderSuccess />} />
              <Route path="/track-order" element={<TrackOrder />} />
              <Route path="/returns-refunds" element={<InfoPage pageKey="returns" />} />
              <Route path="/payments-policy" element={<InfoPage pageKey="payments" />} />
              <Route path="/shipping" element={<InfoPage pageKey="shipping" />} />
              <Route path="/faqs" element={<InfoPage pageKey="faqs" />} />
              <Route path="/profile" element={<Profile />} />
            </Routes>
            </div>
            <Footer />
          </div>
        </CartProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
